import { createApp } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import { createPinia } from "pinia";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
// @ts-expect-error: No types for zh-cn locale file
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import App from "./App.vue";

// 路由配置：统一布局（banner + 导航）+ 子路由只渲染 main-content 区域
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/:keyFlag?",
      component: () => import("./layouts/IRMLayout.vue"),
      children: [
        {
          path: "",
          name: "IRMHome",
          component: () => import("./views/IRMHomePage.vue"),
        },
        {
          path: "announcement/:type",
          name: "Announcement",
          component: () => import("./views/AnnouncementPage.vue"),
          props: true,
        },
        {
          path: "governance/:type",
          name: "Governance",
          component: () => import("./views/GovernancePage.vue"),
          props: true,
        },
        {
          path: "consulting/:type",
          name: "Consulting",
          component: () => import("./views/ConsultingPage.vue"),
          props: true,
        },
        {
          path: "stock/:type",
          name: "Stock",
          component: () => import("./views/StockPage.vue"),
          props: true,
        },
      ],
    },
  ],
});

const DEFAULT_KEY_FLAG = "MTE4P0RGJ";

// 导航守卫：确保 keyFlag 保留在 URL 中
router.beforeEach((to, from, next) => {
  // 如果访问根路径且没有 keyFlag，重定向到带默认 keyFlag 的路径
  if (to.path === "/" && !to.params.keyFlag) {
    next(`/${DEFAULT_KEY_FLAG}`);
    return;
  }

  // 如果从有 keyFlag 的路径跳转，且新路径没有 keyFlag，则保留 keyFlag
  const fromKeyFlag = from.params.keyFlag as string;
  const toKeyFlag = to.params.keyFlag as string;

  if (fromKeyFlag && !toKeyFlag && to.path !== "/") {
    // 构建新路径，保留 keyFlag
    const newPath = `/${fromKeyFlag}${to.path}`;
    next(newPath);
    return;
  }

  next();
});

// Pinia状态管理
const pinia = createPinia();

// 创建Vue应用
const app = createApp(App, {
  // 从URL参数获取租户ID，用于开发和demo
  tenantId:
    new URLSearchParams(window.location.search).get("tenantId") ||
    "demo-tenant",
  mode: "standalone",
  showHeader: false, // 隐藏通用头部，使用页面内置的
  showFooter: false, // 隐藏通用底部
});

app.use(pinia);
app.use(router);
app.use(ElementPlus, {
  locale: zhCn,
});

// 全局错误处理
app.config.errorHandler = (err, instance, info) => {
  console.error("Application error:", err, info);
};

app.mount("#app");
